$(document).ready(function(){
  // AK JS
  $(document).on('click','.drawer_footer .apply-filter',function(){
   console.log('hh')
    var tag_active_legnth = $('#FilterDrawer .filter-form .tag-list li').length;
    console.log(tag_active_legnth);
    var url = $('#FilterDrawer .apply-filter').attr('data-url');
     for(var i=0;i < tag_active_legnth;i++){
       if($('#FilterDrawer .filter-form .tag-list li').eq(i).hasClass('tag--active')){
         var value = $('#FilterDrawer .filter-form .tag-list li').eq(i).find('.tag__input').attr('value');
         value = value.replace(/\s+/g, '+');
         value = value.replace(/\&+/g, '%26');
         value = value.replace(/\;+/g, '%3B');
         if(url.includes('?')){
           var url = url + '&' + $('#FilterDrawer .filter-form .tag-list li').eq(i).find('.tag__input').attr('name') + '=' + value;
         }else{
           var url = url + '?' + $('#FilterDrawer .filter-form .tag-list li').eq(i).find('.tag__input').attr('name') + '=' + value;
         }
       }
     }
    console.log(url)
    window.location.href = url;
    // window.history.pushState({}, null,url);
     // $('#FilterDrawer .filter-form').submit();
    $('.collection_list_btn').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      dots: false,
      adaptiveHeight: true,
      responsive: [
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
    });
  });
  // end AK JS
  $('.cm_collection-list-slider .js_featured_collection_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    speed: 1000,
    centerPadding: '330px',
    dots: true,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerPadding: '200px',
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          centerPadding: '100px',
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerPadding: '80px',
        }
      }
    ]
  });

  $('.cm_collection_slider .grid.grid--uniform').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  $('.template-the-duke-entgeistert .laden_img_gallery .desk_img_gallery,.template-the-duke-sommer-gin .laden_img_gallery .desk_img_gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true
  });
  

  $('.signature_product .signature_content').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '105px',
    dots: true,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          centerPadding: '80px',
        }
      },
       {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerPadding: '50px',
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerPadding: '30px',
        }
      }
    ]
  });
  if ($(window).width() < 769) {
    $('.cm_discover_collections .grid').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '80px',
      dots: true
    });
    $('.discover_more_content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '80px',
      dots: true
    });
  
    $('.discover_section .discover_content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      adaptiveHeight: true,
      dots: true
    });

    $('.js_text_column_slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      dots: false,
      responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
    });

    $('.collection_list_btn').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      dots: false,
      adaptiveHeight: true,
      responsive: [
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
    });
    var dataslideindex = $('.collection_list_btn li.slick-slide a.active').parent().attr('data-slick-index');
    // console.log(dataslideindex);
     $('.collection_list_btn').slick('slickGoTo', dataslideindex);
  }

  // function blogEheight() {
  //   var maxHeight = 0;
  //   $(".blog-page .article__grid-meta").each(function(){
  //     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  //   });
  //   $(".blog-page .article__grid-meta").height(maxHeight);
  // }

  //blogEheight();
  
  // Blog Equeal Height JS
  // $(document).on('click','.loadmore_product',function(){
  //   setTimeout(function(){
  //     blogEheight();
  //   }, 2100);
  // });

  $('.event_img_gallery_slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true
    });

  // Product Grid Equeal Height Js
  // setTimeout(function(){
  //   var maxHeight = 0;
  //   $(".grid-product__content .grid-product__meta").each(function(){
  //     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  //   });
  //   $(".grid-product__content .grid-product__meta").height(maxHeight);
  // }, 1000);

  $('.contact-detail').hide();
  $('.contact-detail:first').show();
   $('#betreff').change(function() {
      $('.contact-detail').hide();
      $('#' + $(this).val()).show();
   });
  
  
  $('.tab_content[data-id]').hide();
  $('.guide_tab_btn:first').addClass('active');
  $('.tab_content[data-id]:first').show();
  $(document).on('click','.guide_tab_btn',function(){
   $('.guide_tab_btn').removeClass('active');
   $(this).addClass('active');
    let currentTab = $(this).attr('id');
    $('.tab_content').hide();   
    $('.tab_content[data-id="' + currentTab + '"]').show();
    $('.tab_content[data-id="' + currentTab + '"]').find('.event_img_gallery_slider').slick('refresh');
    var position = $(this).position();
    var corresponding = $(this).attr("id");

    // scroll to clicked tab with a little gap left to show previous tabs
    scroll = $('.tab_slider_btn').scrollLeft();
    $('.tab_slider_btn').animate({
        'scrollLeft': scroll + position.left - 30
    }, 200);
  });

  $(document).on('click','.collection_list_btn .btn',function(){
    console.log(11);
    var position = $(this).position();

    // scroll to clicked tab with a little gap left to show previous tabs
    scroll = $('.slick-slide.slick-current').scrollLeft();
    $('.slick-slide.slick-current').animate({
        'scrollLeft': scroll + position.left - 30
    }, 200);
  });
    
  $(document).on('click','.tab_prev_btn',function(){
    $('.guide_tour_tab_btn .active').prev('li').trigger('click');
  });

  $(document).on('click','.tab_next_btn',function(){
    $('.guide_tour_tab_btn .active').next('li').trigger('click');
  });
  
  $('.account_content .grid__item[data-id]').hide();
  $('.cm_account_page .btn:first').addClass('active');
  $('.account_content .grid__item[data-id]:first').show();
  $(document).on('click','.cm_account_page .btn',function(e){
    e.preventDefault();
   $('.cm_account_page .btn').removeClass('active');
   $(this).addClass('active');
    let currentTab = $(this).attr('id');
    $('.account_content .grid__item').hide();   
    $('.account_content .grid__item[data-id="' + currentTab + '"]').show();
  });
  
  // if ($(window).width() < 769) {
  //   var maxHeight = 0;
  //   $(".template-drinks .blog-page .article__grid-meta").each(function(){
  //     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  //   });
  //   $(".template-drinks .blog-page .article__grid-meta").height(maxHeight);
  // }


    $(document).on('click','.cl_icon_with_label',function(){
     $('.time').toggle();
      $(this).toggleClass('icon-label');
    })

  $(".disclosure__toggle").click(function(){
    $(".disclosure-list").toggleClass("disclosure-list--visible");
  });
  $(".disclosure-list").find(".disclosure-list__item").each(function(){
    $(this).click(function(e){
      e.preventDefault();
      var currntPath = $(this).find('a').attr("data-value");
      if (currntPath == "en"){
       window.location.href = 'https://127768-2.myshopify.com/en'+location.pathname;
      }
      else{
        var url = location.pathname.replace("/en","");
        window.location.href = 'https://127768-2.myshopify.com'+url;
      }
    });
  });
  
  $(function() {
  
   $('ul.page_scroll_btn a[href="#rum"]').click (function() {
      $('html, body').animate({scrollTop: $('div.index-section[data-id="template--19665992024407__b83d36bc-96f0-43aa-93de-a890605121ac"]').offset().top-200 }, 'slow');
      return false;
    });

    $('ul.page_scroll_btn a[href="#bourbon"]').click (function() {
      $('html, body').animate({scrollTop: $('div.index-section[data-id="template--19665992024407__20c8c3de-e03a-431e-9f35-1c227fe9af11"]').offset().top-200 }, 'slow');
      return false;
    });
     $('ul.page_scroll_btn a[href="#ginfass"]').click (function() {
      $('html, body').animate({scrollTop: $('div.index-section[data-id="template--19665992024407__905a1f93-ffaa-4641-a972-646c3def6f46"]').offset().top-200 }, 'slow');
      return false;
    });
  });
  
  setTimeout(function(){
    var selector = $('.cust-recom .grid');
    var isALARendered;
    
    function ALAcheck() {
        isALARendered = setInterval(function() {
            customALA()
        }, 1000);
    }
    ALAcheck();
  
    function customALA() {
      var selector = $('.cust-recom .grid');
        if (selector.length > 0) {
            clearInterval(isALARendered);
            $('.cust-recom .grid').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
               infinite: false,
              dots:true,
                responsive: [{
                    breakpoint: 769,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      dots:true,
                      autoplay:false
                    },
                 
                      breakpoint: 420,
                      settings: {
                        slidesToShow: 2
                   }
                }]
            });
          
          // var maxHeight = 0;
          // $(".cust-recom .grid-product__content .grid-product__meta .grid-product__title").each(function(){
          //   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
          // });
          // $(".cust-recom .grid-product__content .grid-product__meta .grid-product__title").height(maxHeight);

          var maxHeight = 0;
          $(".cust-recom .grid-product__content .grid-product__meta").each(function(){
            if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
          });
          $(".cust-recom .grid-product__content .grid-product__meta").height(maxHeight);
          
        };
      }
  }, 1000);


  // custom_code for add gift product in cart

  $('.template-product form.product-single__form .add-to-cart').on('click',function(e){
    console.log("hh");
     
    let items = document.querySelectorAll('[name="bundleGroup"]:checked');
    // console.log(items);
      if(items)
      {      
        var main_prod_id = $('.template-product form.product-single__form [name="id"]').val();
        var timestamp = Math.round(new Date().getTime()/1000);
        var qty_main = $(".product-block.pdp_quantity .js-qty__num").val();
       let arr = [];
         
        if(items.length){
            items.forEach((v)=>{
              var vId = $(v).attr('data-id');
              
              arr.push({id: vId, quantity: 1, "properties" : {"_bundle": "bundle-"+timestamp } });   
            });
        }
      arr.push({id: main_prod_id, quantity:qty_main, "properties" : {"subvar_id": $('[name="bundleGroup"]:checked').attr('data-id') ,"_bundle": "bundle-"+timestamp } });  
      
      let formData = {'items': arr};
      console.log('formData-',formData);
  
    $(".add-to-cart").addClass('btn--loading');
        fetch('/cart/add.js', {
            body: JSON.stringify(formData),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          }).then((response) => {
            return response.json();
          }).then((res) => {
            /* yay! our products were added - do something here to indicate to the user */
          $(".add-to-cart").removeClass('btn--loading');
          if(res.status && res.status == 422){
            console.log("Inventory Error !");
          }else{
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            }
          }).catch((err) => {
            /* uh oh, we have error. */
            console.error(err)
          });
        return false;
      }
      else
      {
        return true;
      }
  });

  $(document).on("click",".cart__remove .text-link",function(){
    if($(this).parents(".cart__item").hasClass("main_pro"))
    {
      var pro_id = $(this).parents(".cart__item.main_pro").attr("data-timestemp");
      $(".cart__item:not(.main_pro)[data-timestemp='"+ pro_id +"']").find(".cart__remove a").trigger("click");
    }
  });

  //load more js 
  $('.collection_load_more').on('click', function(){
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    $this.find('[load-more-text]').addClass('hide');
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.grid.grid--uniform').append($(responseHTML).find('.grid.grid--uniform').html());
      },
      complete: function() {
        if(currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
          if(currentPage == totalPages) {
           $this.hide();
          }
          $('.load-more_wrap').addClass('load_more_hide');
        } 
      }
    })
  });
  
  // ===== Scroll to Top ==== 
  $(window).scroll(function() {
      if ($(this).scrollTop() >= 500) {     
          $('#return-to-top').fadeIn(300);  
      } else {
          $('#return-to-top').fadeOut(300);
      }
  });
  $('#return-to-top').click(function() {
      $('body,html').animate({
          scrollTop : 0
      }, 500);
  });
  
  $('.no_btn').click(function(){
      $('.not_view_error').addClass('show_er');
  });
  $('.yes_btn').click(function(){
      $('.not_view_error').removeClass('show_er');
  });

  $(document).on('click','.close_announcement',function(){
    $('.top-annouce').hide();
  });

});

$(document).ready(function(){

  if ($('.text-with-icons').html() == '\n  \n'){
    $('.shopify-section.product-text-icon').hide();
  }
  if ($('.text-with-icons__blocks').html() == '\n     \n     \n    '){
      $('.shopify-section.product-text-icon').hide();
  }
 
  
  })
// // Contact Custom Dropdown JS
// var x, i, j, l, ll, selElmnt, a, b, c;
// /*look for any elements with the class "custom-select":*/
// x = document.getElementsByClassName("custom-select");
// l = x.length;
// for (i = 0; i < l; i++) {
//   selElmnt = x[i].getElementsByTagName("select")[0];
//   ll = selElmnt.length;
//   /*for each element, create a new DIV that will act as the selected item:*/
//   a = document.createElement("DIV");
//   a.setAttribute("class", "select-selected");
//   a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
//   x[i].appendChild(a);
//   /*for each element, create a new DIV that will contain the option list:*/
//   b = document.createElement("DIV");
//   b.setAttribute("class", "select-items select-hide");
//   for (j = 1; j < ll; j++) {
//     /*for each option in the original select element,
//     create a new DIV that will act as an option item:*/
//     c = document.createElement("DIV");
//     c.innerHTML = selElmnt.options[j].innerHTML;
//     c.addEventListener("click", function(e) {
//         /*when an item is clicked, update the original select box,
//         and the selected item:*/
//         var y, i, k, s, h, sl, yl;
//         s = this.parentNode.parentNode.getElementsByTagName("select")[0];
//         sl = s.length;
//         h = this.parentNode.previousSibling;
//         for (i = 0; i < sl; i++) {
//           if (s.options[i].innerHTML == this.innerHTML) {
//             s.selectedIndex = i;
//             h.innerHTML = this.innerHTML;
//             y = this.parentNode.getElementsByClassName("same-as-selected");
//             yl = y.length;
//             for (k = 0; k < yl; k++) {
//               y[k].removeAttribute("class");
//             }
//             this.setAttribute("class", "same-as-selected");
//             break;
//           }
//         }
//         h.click();
//     });
//     b.appendChild(c);
//   }
//   x[i].appendChild(b);
//   a.addEventListener("click", function(e) {
//       /*when the select box is clicked, close any other select boxes,
//       and open/close the current select box:*/
//       e.stopPropagation();
//       closeAllSelect(this);
//       this.nextSibling.classList.toggle("select-hide");
//       this.classList.toggle("select-arrow-active");
//     });
// }
// function closeAllSelect(elmnt) {
//   /*a function that will close all select boxes in the document,
//   except the current select box:*/
//   var x, y, i, xl, yl, arrNo = [];
//   x = document.getElementsByClassName("select-items");
//   y = document.getElementsByClassName("select-selected");
//   xl = x.length;
//   yl = y.length;
//   for (i = 0; i < yl; i++) {
//     if (elmnt == y[i]) {
//       arrNo.push(i)
//     } else {
//       y[i].classList.remove("select-arrow-active");
//     }
//   }
//   for (i = 0; i < xl; i++) {
//     if (arrNo.indexOf(i)) {
//       x[i].classList.add("select-hide");
//     }
//   }
// }
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
//document.addEventListener("click", closeAllSelect);

function productEheight() {
  // var maxHeight = 0;
  // $(".grid-product__content .grid-product__meta .grid-product__title").each(function(){
  // if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  // });
  // $(".grid-product__content .grid-product__meta .grid-product__title").height(maxHeight);
  
  var maxHeight = 0;
  $(".grid-product__content .grid-product__meta").each(function(){
  if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".grid-product__content .grid-product__meta").height(maxHeight);
}
productEheight();

$(document).on('click','.collection_load_more a',function(){
  setTimeout(function(){
    productEheight();
  },2100);
});
  
$(document).ready(function(){  
    $(" .announcement-bar.header-top-bar .fix_link .announcement-slider__slide").click(function(){  
        $(".contact_link").toggleClass("active");  
    });  
});  

// Event Page Scroll Js
$(".event_next_sec_scroll").click(function(e) {
  e.preventDefault();
  $('html,body').animate({
      scrollTop: $(".inquiry_form").offset().top - 126},
      'slow'); 
});

// Article Image Gallery Slider
$('.cm_article_img_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true
});